import { getFlexibleDeparturePolicy } from 'lib/helper/flexible-departure/flexible-departure';
import { useTenant } from './useTenant';

const useFlexibleDeparturePolicy = () => {
  const { isDA } = useTenant();

  return getFlexibleDeparturePolicy(isDA);
};

export { useFlexibleDeparturePolicy };
